/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://statefulcoders.com/product/material-dashboard-react
* Copyright 2025 Stateful Coders (https://https://statefulcoders.com)

Coded by https://statefulcoders.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import borders from "assets/theme-dark/base/borders";
import boxShadows from "assets/theme-dark/base/boxShadows";
import breakpoints from "assets/theme-dark/base/breakpoints";

const { borderRadius } = borders;
const { xxl } = boxShadows;

const dialog = {
  styleOverrides: {
    paper: {
      borderRadius: borderRadius.lg,
      boxShadow: xxl,
      margin: "16px",
      maxHeight: "calc(100% - 32px)",

      // Mobile optimizations
      [`@media (max-width: ${breakpoints.values.sm}px)`]: {
        margin: "8px",
        maxHeight: "calc(100% - 16px)",
        borderRadius: borderRadius.md,
        width: "calc(100% - 16px)",
        maxWidth: "calc(100% - 16px)",
      },

      // Very small screens - nearly full screen
      [`@media (max-width: ${breakpoints.values.xs + 100}px)`]: {
        margin: "4px",
        maxHeight: "calc(100% - 8px)",
        borderRadius: borderRadius.sm,
        width: "calc(100% - 8px)",
        maxWidth: "calc(100% - 8px)",
      },
    },

    paperFullScreen: {
      borderRadius: 0,
    },

    // Improve backdrop for mobile
    root: {
      [`@media (max-width: ${breakpoints.values.sm}px)`]: {
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
      },
    },
  },
};

export default dialog;
